import { render, staticRenderFns } from "./RateTypeRoomRestriction.vue?vue&type=template&id=071dd568&"
import script from "./RateTypeRoomRestriction.vue?vue&type=script&lang=js&"
export * from "./RateTypeRoomRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071dd568')) {
      api.createRecord('071dd568', component.options)
    } else {
      api.reload('071dd568', component.options)
    }
    module.hot.accept("./RateTypeRoomRestriction.vue?vue&type=template&id=071dd568&", function () {
      api.rerender('071dd568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RateTypeRoomRestriction.vue"
export default component.exports